define([
    'jQuery',
    'underscore',
    'moment',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object',
    'library/fcse-dropdown/dropdown',
    'library/fcse-visibilitycontrol/visibilityControl',
    'perfect-scrollbar',
    'jQueryUI',
    'library/fcse-datepicker/i18n/datepicker-de',
    'library/fcse-datepicker/i18n/datepicker-es',
    'library/fcse-datepicker/i18n/datepicker-nl'],
        function($, _, moment, Widget, Object, Dropdown, VisibilityControl, PerfectScrollBar) {

            var TravelPerdiodWidget = function(element, options) {
                Widget.apply(this, arguments);
                var self = this;
                var defaultOptions = {
                    'periodCaptionDatesClassName' : 'widget-travelperiod--dates',
                    'periodCaptionDurationClassName' : 'widget-travelperiod--duration',
                    'hiddenClassName' : 'is-hidden',
                    'disableClassName' : 'is-disabled',
                    'durationTypeExact' : 'exact',
                    'durationTypeRange' : 'range',
                    'valueAnyPeriod' : '-1',
                    'captionIsHtml' : true,
                    'submitOn' : []
                };
                /* I18N
                 * 1. Use "" for english
                 * 2. The i18n package for a language for datepicker should be bound as dependency.
                 *    For ex.: for "de" use library/jquery-ui/ui/i18n/jquery.ui.datepicker-de.js
                 * 3. Extend the requirejs config so this file is properly shimed.
                 */
                switch (window.locale) {
                    case 'nl':
                        defaultOptions.language = 'nl';
                        break;
                    case 'es':
                        defaultOptions.language = 'es';
                        break;
                    default:
                        defaultOptions.language = 'de';
                        break;
                }
                //Add default options and custom options
                this.addOptions(defaultOptions, options);

                // Duration Dropdown
                this.durationDropdown = {};

                // DepartureDate-Datepicker
                this.departureDateDatepicker = $('[data-fcse-role="travelperiod--departuredate-datepicker"]', this.element);

                // ReturnDate-Datepicker
                this.returnDateDatepicker = $('[data-fcse-role="travelperiod--returndate-datepicker"]', this.element);

                // LongtimeAlert-Button
                this.longtimeAlertButton = $('#widget-durationchooser').find('[data-fcse-role="travelperiod--longtimealert"]');

                // Duration Type Chooser
                this.durationTypeChooser = $('[data-fcse-role="travelperiod--durationtype"]');

                // Initialize
                this._initDatePicker();
                this._initDurationDropdown();
                this._initDuratonTypeChooser();
                this._initLongtimeAlertButton();
                this._blockClickPropagation();

                // We need to notify flyout to update caption
                setTimeout(function() {
                    self.dispatchEvent("change");
                }, 150);
            };

            TravelPerdiodWidget.prototype = $.extend(Object.create(Widget.prototype), {

                _initLongtimeAlertButton: function() {
                    this.longtimeAlertButton.on('click', $.proxy(this._onLongtimeAlertButtonClick, this));
                },

                _onLongtimeAlertButtonClick: function(e) {
                    // Stop Propagation / Prevent Default Handling
                    e.stopPropagation();
                    e.preventDefault();

                    // Close Dropdown
                    this.durationDropdown.closeDropdown();

                    // Initialize Visibility Control Target
                    var callerElement = $('#widget-durationchooser').find('[data-fcse-role="travelperiod--longtimealert"]');
                    var visibilityControl = new VisibilityControl(callerElement);
                    visibilityControl.toggleTarget(callerElement, $(callerElement.data('target')));
                },

                _initDuratonTypeChooser: function() {
                    this.durationTypeChooser.on('change', $.proxy(this._onDurationTypeChange, this));
                },

                _onDurationTypeChange: function(e) {
                    if(e.currentTarget.value == this.option('durationTypeExact')) {
                       // Disable Duration Dropdown
                       this.durationDropdown.element.addClass(this.option('disableClassName'));
                       $('button', this.durationDropdown.element).attr('disabled', 'disabled');
                       // Restrict maxDate / Set new Duration
                       var departureDate = this.departureDateDatepicker.datepicker("getDate");
                       var returnDate = this.returnDateDatepicker.datepicker("getDate");
                       var diffDays = Math.min(28, moment(returnDate).diff(moment(departureDate), "days"));
                       var maxDate = moment(new Date(departureDate.getTime())).add(diffDays, "days").toDate();
                       var maxDateLimit = moment(new Date(departureDate.getTime())).add(28, "days").toDate();

                       this.returnDateDatepicker.datepicker("setDate", maxDate);
                       this.returnDateDatepicker.datepicker("option", "maxDate", maxDateLimit);

                       this.durationDropdown.setValue(diffDays);

                        // Check radio buttons
                        $('[value="'+this.option('durationTypeRange')+'"]', this.element).removeAttr('checked');
                        $('[value="'+this.option('durationTypeExact')+'"]', this.element).attr('checked', 'checked');
                    } else {
                        // Re-Activate Duration Dropdown
                        this.durationDropdown.element.removeClass(this.option('disableClassName'));
                        $('button', this.durationDropdown.element).removeAttr('disabled');
                        // Every Date is possible
                        this.returnDateDatepicker.datepicker("option", "maxDate", null);
                        this.durationDropdown.setValue(this.option('valueAnyPeriod'));

                        // Check radio buttons
                        $('[value="'+this.option('durationTypeExact')+'"]', this.element).removeAttr('checked');
                        $('[value="'+this.option('durationTypeRange')+'"]', this.element).attr('checked', 'checked');
                    }
                    if (this.option('submitOn').indexOf('periodTypeChange') != -1) {
                        this.accept();
                    }
                },

                _initDurationDropdown: function() {
                    var dropDownElem = $('[data-fcse-role="travelperiod--durationchooser-dropdown"]');
                    var dropDownContent = $('[data-fcse-role="dropdown--content"]', dropDownElem).get(0);
                    if(!dropDownContent) {
                        return;
                    }
                    PerfectScrollBar.initialize(dropDownContent);
                    // PerfectScrollBar.update($('[data-fcse-role="dropdown--content"]', dropDownElem).get(0));
                    this.durationDropdown = new Dropdown(dropDownElem);
                    this.durationDropdown.on('close', $.proxy(this._onDurationClose, this));
                    this.durationDropdown.on('open', function() {
                        PerfectScrollBar.update(dropDownContent);
                    });
                },

                _onDurationClose: function() {
                    // Get current Departure-Date
                    var departureDate = this.departureDateDatepicker.datepicker("getDate");

                    // Get Current Return-Date
                    var returnDate = this.returnDateDatepicker.datepicker("getDate");

                    // Set new Return-Date
                    var diffDays = moment(returnDate).diff(moment(departureDate), "days");
                    if(diffDays < this._getDurationMaxDays()) {
                        var returnDateWithDurationMaxDays = moment(new Date(departureDate.getTime())).add(this._getDurationMaxDays(), "days");
                        this.returnDateDatepicker.datepicker("setDate", returnDateWithDurationMaxDays.toDate());
                    }
                    if (this.option('submitOn').indexOf('durationChange') != -1) {
                        this.accept();
                    }
                },

                _getDurationMaxDays: function() {
                    // Get current Duration value
                    var duration = this.durationDropdown.getValue();

                    // Get highest value of the range and set as duration
                    if(_.isString(duration) && duration.indexOf('-') >= 0) { // Range
                        var durationParts = duration.split('-');
                        if(_.size(durationParts) == 2) { // Got exactly two values
                            duration = durationParts[1];
                        }
                    }
                    return duration;
                },

                _getDurationMinDays: function() {
                    // Get current Duration value
                    var duration = this.durationDropdown.getValue();

                    // Get highest value of the range and set as duration
                    if(_.isString(duration) && duration.indexOf('-') >= 0) { // Range
                        var durationParts = duration.split('-');
                        if(_.size(durationParts) == 2) { // Got exactly two values
                            duration = durationParts[0];
                        }
                    }
                    return duration;
                },

                _initDatePicker: function() {
                    if(!this.value) {
                        return;
                    }

                    var departureDatapickerOptions = $.extend({
                          dateFormat: "dd.mm.y",
                          minDate: "+1d",
                          defaultDate: moment(this.value.departureDate, "YYYY-MM-DD").toDate(),
                          onSelect: $.proxy(this._onDepartureDatepickerSelect, this)
                      },
                      $.datepicker.regional[this.option('language')]
                    );

                    var returnDatapickerOptions = $.extend({
                          dateFormat: "dd.mm.yy",
                          minDate: moment(this.value.departureDate, "YYYY-MM-DD").add(1, "day").toDate(),
                          defaultDate: moment(this.value.returnDate, "YYYY-MM-DD").toDate(),
                          onSelect: $.proxy(this._onReturnDatepickerSelect, this)
                      },
                      $.datepicker.regional[ this.option('language') ]
                    );

                    if (window.locale === 'es') {
                        departureDatapickerOptions.monthNames = departureDatapickerOptions.monthNames
                          .map(monthName => this._lowerCase(monthName));
                        returnDatapickerOptions.monthNames = returnDatapickerOptions.monthNames
                          .map(monthName => this._lowerCase(monthName));
                    }

                    // Initialize Departure-Datepicker
                    this.departureDateDatepicker.datepicker(departureDatapickerOptions);

                    // Initialize Return-Datepicker
                    this.returnDateDatepicker.datepicker(returnDatapickerOptions);
                },

                _blockClickPropagation: function() {
                    // We should block click propagation, otherwise flyout will be closed when months are changed
                    $(this.element).click(function(e){
                        e.stopPropagation();
                    });
                },

                _lowerCase: function(string) {
                    return string.toLowerCase();
                },

                _getDurationTypeValue: function() {
                    return $('[data-fcse-role="travelperiod--durationtype"]:checked').val();
                },

                _onDepartureDatepickerSelect: function() {
                    var self = this;

                    // MinDate / MaxDate
                    var departureDate = self.departureDateDatepicker.datepicker("getDate");
                    var returnDate = self.returnDateDatepicker.datepicker("getDate");

                    var diffDays = moment(returnDate).diff(moment(departureDate), "days");

                    if(self._getDurationTypeValue() == self.option('durationTypeExact')) { // Exact Dates
                        // Set new Date
                        if (diffDays < 1) {
                            self.returnDateDatepicker.datepicker("setDate", moment(new Date(departureDate.getTime())).add(1, "days").toDate());
                       }

                       // Set New MaxDate
                       self.returnDateDatepicker.datepicker("option", "maxDate", moment(new Date(departureDate.getTime())).add(28, "days").toDate());
                    } else {
                        // Set new Date
                        if (diffDays < self._getDurationMaxDays()) {
                            self.returnDateDatepicker.datepicker("setDate", moment(new Date(departureDate.getTime())).add(self._getDurationMaxDays(), "days").toDate());
                        }
                    }

                    // In returndate-calendar select of earlier dates than
                    // departuredate should not be possible.
                    self.returnDateDatepicker.datepicker("option", "minDate", moment(new Date(departureDate.getTime())).add(1, "days").toDate());

                    // Close Datepicker
                    self.departureDateDatepicker.trigger('click');

                },

                _onReturnDatepickerSelect: function() {
                    var self = this;

                    // MinDate / MaxDate
                    var minDate = self.departureDateDatepicker.datepicker("getDate");
                    var maxDate = self.returnDateDatepicker.datepicker("getDate");

                    // Limiting duration by its max possible
                    // value which is (return date - departure date).
                    self._setMaxDuration(minDate, maxDate);

                    // Close Datepicker
                    self.returnDateDatepicker.trigger('click');

                },

                formatValue: function() {
                    var val = this.getValue();
                    var formattedValue = '';

                    if (val && this.durationDropdown.formatValue()) {
                        var period = $('<span>').text(moment(val.departureDate).format('DD.MM.YY') + ' - ' + moment(val.returnDate).format('DD.MM.YY'));
                        period.addClass(this.option('periodCaptionDatesClassName'));

                        var duration = $('<span>').text(this.durationDropdown.formatValue());
                        duration.addClass(this.option('periodCaptionDurationClassName'));

                        formattedValue = $($('<div></div>').html(period.clone())).html();

                        if (val.exactDepartureDate && val.exactReturnDate) {
                            // formattedValue = formattedValue + ', ' + $($('<div></div>').html(duration.clone())).html();
                        } else {
                            // formattedValue = formattedValue + ', ' + $($('<div></div>').html(duration.clone())).html();
                        }
                    }
                    return formattedValue;
                },

                setValueToUi: function() {
                    var departureDate = moment(this.value.departureDate, "YYYY-MM-DD").toDate();
                    var returnDate = moment(this.value.returnDate, "YYYY-MM-DD").toDate();
                    this.departureDateDatepicker.datepicker("setDate", departureDate);
                    this.returnDateDatepicker.datepicker("setDate", returnDate);

                    // set Duration Value
                    this.durationDropdown.setValue(this.value.duration);

                    // Exact Return+Departure Date
                    if(this.value.exactReturnDate && this.value.exactReturnDate == true && this.value.exactDepartureDate && this.value.exactDepartureDate == true) {
                        // Set value of DurationType-Chooser
                        $('[value="'+this.option('durationTypeRange')+'"]', this.element).removeAttr('checked');
                        $('[value="'+this.option('durationTypeExact')+'"]', this.element).attr('checked', 'checked');

                        var departureDateWithMaxDuration = moment(this.value.departureDate, "YYYY-MM-DD").add(28, "days").toDate();
                        this.returnDateDatepicker.datepicker("option", "maxDate", departureDateWithMaxDuration);
                    } else {
                        // Set Value of DurationType-Chooser
                        $('[value="'+this.option('durationTypeExact')+'"]', this.element).removeAttr('checked');
                        $('[value="'+this.option('durationTypeRange')+'"]', this.element).attr('checked', 'checked');

                        this.returnDateDatepicker.datepicker("option", "maxDate", null);
                    }
                },

                getValueFromUi: function() {
                    var departureDate = moment(this.departureDateDatepicker.datepicker("getDate"));
                    var returnDate = moment(this.returnDateDatepicker.datepicker("getDate"));
                    var isExactDurationType = (this._getDurationTypeValue() == this.option('durationTypeExact'));

                    // Set Calculated Duration when both exact Departure and Return-Date are set.
                    if(isExactDurationType) {
                        //params.duration = 0;
                        var diffDays = Math.min(28, returnDate.diff(departureDate, "days"));
                        this.durationDropdown.setValue(diffDays);
                    }

                    var params = {
                        departureDate: departureDate.format("YYYY-MM-DD"),
                        returnDate: returnDate.format("YYYY-MM-DD"),
                        duration: this.durationDropdown.getValue(),
                        exactDepartureDate: isExactDurationType,
                        exactReturnDate: isExactDurationType
                    };

                    return params;
                },

                _setMaxDuration: function(minDate, maxDate) {
                    var diffDays = Math.min(28, moment(maxDate).diff(moment(minDate), "days"));
                    var minDays = this._getDurationMinDays();
                    var maxDays = this._getDurationMaxDays();

                    if(minDays != maxDays) { // Range
                        if(minDays > diffDays || maxDays > diffDays) {
                            this.durationDropdown.setValue(diffDays);
                        }
                    } else { // Single value
                        if(maxDays > diffDays) {
                            this.durationDropdown.setValue(diffDays);
                        }
                    }
                }
            });

            return TravelPerdiodWidget;
        }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/travelperiod/travelPeriodWidget.js